<template>
  <ion-img
    v-if="feature.icon"
    @ionError="onError"
    :src="imageSrc"
    style="opacity: 0.45; width: 25px"
  />
  <p class="ion-padding-start padding-list-item ion-padding-start text-color-body text-lg">
    {{ feature[`name_${language}` as keyof typeof feature] }}
  </p>
</template>
<script setup lang="ts">
  import { IonImg } from '@ionic/vue';
  import { ContractModelRelation } from '@/interfaces/elastic/elastic.interface';
  import { PropType, ref } from 'vue';

  const props = defineProps({
    feature: {
      type: Object as PropType<ContractModelRelation>,
      required: true,
    },
    language: {
      type: String,
      required: true,
    },
  });

  const imageSrc = ref(props.feature.icon);

  const onError = () => {
    imageSrc.value =
      'https://lodgerin-rentals-production.s3.gra.io.cloud.ovh.net/public/features/feature-icon-5.png';
  };
</script>
<style scoped lang="scss"></style>
